import { render, staticRenderFns } from "./addProductOrder.vue?vue&type=template&id=7538b8e1&scoped=true"
import script from "./addProductOrder.vue?vue&type=script&lang=js"
export * from "./addProductOrder.vue?vue&type=script&lang=js"
import style0 from "./addProductOrder.vue?vue&type=style&index=0&id=7538b8e1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7538b8e1",
  null
  
)

export default component.exports